module.exports = __webpack_public_path__ + "media/recipes/142-ab72ee08.png";